import { defineRecipe as i } from "@pandacss/dev";
import { chipRecipe as e, typographyRecipe as a } from "@huspy/briks-core";
const r = i({
  className: "chip",
  base: { ...e.base, ...a.size["sans-serif"].md },
  variants: {
    variant: e.variant,
    size: e.size
  },
  defaultVariants: {
    variant: "neutral",
    size: "md"
  }
});
export {
  r as chipRecipe
};
